(() => {
  const namespace = (window.KGGroutCalculator =
    window.KGGroutCalculator || {});

  const DEFAULT_GROUT_COEFFICIENT = 1.75;

  const GROUT_COEFFICIENTS = [
    {
      match: 'ultracolor-plus',
      coefficient: 1.75
    },
    {
      match: 'keracolor-ff',
      coefficient: 1.6
    }
  ];

  const EASY_LEVEL_BAND_TABLE = {
    10: { 10: 200 },
    15: { 10: 133, 15: 89 },
    20: { 10: 100, 15: 67, 20: 50 },
    25: { 10: 80, 15: 53, 20: 40, 25: 32 },
    30: { 10: 100, 15: 67, 20: 50, 25: 40, 30: 44 },
    33: { 10: 91, 15: 61, 20: 45, 25: 36, 30: 40, 33: 37 },
    40: { 10: 75, 15: 50, 20: 37, 25: 30, 30: 33, 33: 30, 40: 25 },
    45: { 10: 67, 15: 44, 20: 33, 25: 27, 30: 30, 33: 27, 40: 22, 45: 20 },
    50: { 10: 60, 15: 40, 20: 30, 25: 24, 30: 27, 33: 24, 40: 20, 45: 18, 50: 16 },
    60: { 10: 50, 15: 33, 20: 25, 25: 20, 30: 22, 33: 20, 40: 17, 45: 15, 50: 13, 60: 11 },
    80: { 10: 50, 15: 33, 20: 25, 25: 20, 30: 21, 33: 19, 40: 16, 45: 14, 50: 12, 60: 10, 80: 9 },
    90: { 10: 44, 15: 30, 20: 22, 25: 18, 30: 19, 33: 17, 40: 14, 45: 12, 50: 11, 60: 9, 80: 8, 90: 7 },
    100: { 10: 50, 15: 33, 20: 25, 25: 20, 30: 20, 33: 18, 40: 15, 45: 13, 50: 12, 60: 10, 80: 9, 90: 8, 100: 8 },
    120: { 10: 42, 15: 28, 20: 21, 25: 17, 30: 17, 33: 15, 40: 13, 45: 11, 50: 10, 60: 8, 80: 7, 90: 6, 100: 7, 120: 6 }
  };

  namespace.constants = {
    DEFAULT_GROUT_COEFFICIENT,
    EASY_LEVEL_BAND_TABLE,
    FASTMASSA_MARGIN_FACTOR: 1.1,
    SILICONE_MARGIN_FACTOR: 1.15,
    PRIMER_CONSUMPTION_MIN_KG_PER_M2: 0.2,
    PRIMER_CONSUMPTION_MAX_KG_PER_M2: 0.3,
    PIEDESTAL_MARGIN_FACTOR: 1.1,
    LEVELING_MARGIN_FACTOR: 1.1,
    LEVELING_STANDARD_SPACING_MM: 300,
    LEVELING_LARGE_FORMAT_SPACING_MM: 250,
    SPACER_MARGIN_FACTOR: 1.15
  };

  namespace.resolveGroutCoefficient = (groutHandle) => {
    if (!groutHandle) {
      return DEFAULT_GROUT_COEFFICIENT;
    }

    const matchedProfile = GROUT_COEFFICIENTS.find(
      ({ match }) => groutHandle.includes(match)
    );

    return (
      matchedProfile?.coefficient ??
      DEFAULT_GROUT_COEFFICIENT
    );
  };

  namespace.parseLocalizedNumber = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return NaN;
    }

    const normalized = String(value)
      .trim()
      .replace(/\s/g, '')
      .replace(',', '.');

    return Number.parseFloat(normalized);
  };

  namespace.parseTileDimensions = (value) => {
    if (!value) {
      return null;
    }

    const normalized = String(value)
      .toLowerCase()
      .replace(/centimeter/g, '')
      .replace(/cm/g, '')
      .replace(/×/g, 'x')
      .replace(/\*/g, 'x')
      .replace(/,/g, '.')
      .trim();

    const matches = normalized.match(
      /(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/
    );

    if (!matches) {
      return null;
    }

    const lengthCm = Number.parseFloat(matches[1]);
    const widthCm = Number.parseFloat(matches[2]);

    if (
      !Number.isFinite(lengthCm) ||
      !Number.isFinite(widthCm) ||
      lengthCm <= 0 ||
      widthCm <= 0
    ) {
      return null;
    }

    return {
      lengthCm,
      widthCm,
      lengthMm: lengthCm * 10,
      widthMm: widthCm * 10
    };
  };

  namespace.formatNumber = (
    value,
    maximumFractionDigits = 2
  ) =>
    new Intl.NumberFormat('sv-SE', {
      minimumFractionDigits: 0,
      maximumFractionDigits
    }).format(value);

  namespace.formatWeight = (weightKg) => {
    if (weightKg < 1) {
      return `${namespace.formatNumber(weightKg * 1000, 0)} g`;
    }

    return `${namespace.formatNumber(weightKg, 2)} kg`;
  };

  namespace.translateDeliveryText = (text = '') => {
    const lang = window.currentLanguage || 'sv';

    if (lang !== 'da') {
      return text;
    }

    return String(text)
      .replace(/arbetsdagar/gi, 'arbejdsdage')
      .replace(/leveranstid/gi, 'leveringstid')
      .replace(/dagar/gi, 'dage')
      .replace(/Beställningsvara/gi, 'Bestillingsvare')
      .replace(/Lagervara/gi, 'Lagervare');
  };

  namespace.resolveSiliconeVolumeMl = (title = '') => {
    const match = title.match(/(\d+(?:[.,]\d+)?)\s*ml/i);

    if (match) {
      return namespace.parseLocalizedNumber(match[1]);
    }

    return 300;
  };

  namespace.resolvePrimerPackageUnits = (title = '') => {
    const match = title.match(
      /(\d+(?:[.,]\d+)?)\s*(l|liter|liters|kg)\b/i
    );

    if (match) {
      return namespace.parseLocalizedNumber(match[1]);
    }

    return 1;
  };

  namespace.normalizePrimerTitle = (title = '') =>
    String(title || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

  const PRIMER_CONSUMPTION_PROFILES = [
    {
      matches: ['4410 vapourstop', 'vapourstop'],
      min: 0.15,
      max: 0.15,
      unit: 'kg'
    },
    {
      matches: ['primer eco', 'primer eco se'],
      min: 0.1,
      max: 0.15,
      unit: 'l'
    },
    {
      matches: ['primer vt plus', 'mapei primer vt plus'],
      min: 0.3,
      max: 0.3,
      unit: 'kg'
    },
    {
      matches: ['eco prim grip', 'mapei eco prim grip'],
      min: 0.2,
      max: 0.3,
      unit: 'kg'
    },
    {
      matches: ['eco prim t plus', 'primer eco prim t plus'],
      min: 0.03,
      max: 0.15,
      unit: 'kg'
    },
    {
      matches: ['grip a920 premium', 'grip a920'],
      min: 0.2,
      max: 0.2,
      unit: 'kg'
    },
    {
      matches: ['grip a936 xpress', 'grip a936'],
      min: 0.1,
      max: 0.3,
      unit: 'kg'
    },
    {
      matches: ['grip a560 classic', 'grip a560'],
      min: 0.08,
      max: 0.3,
      unit: 'l'
    },
    {
      matches: ['4180 primer', 'bostik 4180 primer'],
      min: 0.08,
      max: 0.2,
      unit: 'l'
    }
  ];

  namespace.resolvePrimerConsumptionProfile = (
    title = ''
  ) => {
    const normalizedTitle =
      namespace.normalizePrimerTitle(title);

    const matchedProfile =
      PRIMER_CONSUMPTION_PROFILES.find((profile) =>
        profile.matches.some((match) =>
          normalizedTitle.includes(match)
        )
      );

    if (matchedProfile) {
      return matchedProfile;
    }

    return {
      min: namespace.constants
        .PRIMER_CONSUMPTION_MIN_KG_PER_M2,
      max: namespace.constants
        .PRIMER_CONSUMPTION_MAX_KG_PER_M2,
      unit: 'kg'
    };
  };

  namespace.resolveFastmassaPackageKg = (title = '') => {
    const match = title.match(
      /(\d+(?:[.,]\d+)?)\s*kg\b/i
    );

    if (match) {
      return namespace.parseLocalizedNumber(match[1]);
    }

    return 20;
  };

  namespace.normalizeFastmassaTitle = (title = '') =>
    String(title || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

  const FASTMASSA_CONSUMPTION_PROFILES = [
    {
      matches: ['adesilex p9', 'mapei adesilex p9'],
      resolveConsumption: ({ maxSide }) => {
        if (maxSide <= 15) return 2;
        if (maxSide >= 60) return 5;
        return 2.75;
      }
    },
    {
      matches: ['ultralite s1', 'mapei ultralite s1'],
      resolveConsumption: ({ maxSide }) => {
        if (maxSide <= 15) return 1.5;
        if (maxSide >= 60) return 2.5;
        return 2;
      }
    },
    {
      matches: ['ultramastic iii', 'mapei ultramastic iii'],
      resolveConsumption: ({ maxSide }) => {
        if (maxSide <= 10) return 1.5;
        if (maxSide <= 15) return 2.5;
        return 3.75;
      }
    },
    {
      matches: ['8040 flow', 'bostik 8040 flow', 'fix 8040 flow'],
      resolveConsumption: ({ maxSide }) => {
        if (maxSide <= 30) return 5;
        if (maxSide <= 45) return 6.5;
        return 8;
      }
    },
    {
      matches: ['8050', 'bostik 8050', 'fix 8050'],
      resolveConsumption: ({ maxSide }) => {
        if (maxSide <= 15) return 1.5;
        if (maxSide >= 60) return 4;
        return 2.75;
      }
    },
    {
      matches: ['8060', 'bostik 8060', 'fix 8060'],
      resolveConsumption: ({ maxSide }) => {
        if (maxSide <= 15) return 1.5;
        if (maxSide >= 60) return 3;
        return 2.25;
      }
    },
    {
      matches: ['8070 lt', 'bostik 8070 lt', 'fix 8070 lt'],
      resolveConsumption: ({ maxSide }) => {
        if (maxSide <= 15) return 1.1;
        if (maxSide >= 60) return 2.2;
        return 1.65;
      }
    },
    {
      matches: ['3110 unifix', 'bostik 3110 unifix', 'unifix'],
      resolveConsumption: ({ maxSide }) => {
        if (maxSide <= 20) return 2.5;
        if (maxSide >= 60) return 3.5;
        return 3;
      }
    },
    {
      matches: ['3130 superfix', 'bostik 3130 superfix', 'superfix'],
      resolveConsumption: ({ maxSide }) => {
        if (maxSide <= 20) return 2.5;
        if (maxSide >= 60) return 3.5;
        return 3;
      }
    },
    {
      matches: [
        '3230 superrapidfix',
        'bostik 3230 superrapidfix',
        'superrapidfix'
      ],
      resolveConsumption: ({ maxSide }) => {
        if (maxSide <= 20) return 2.5;
        if (maxSide >= 60) return 3.5;
        return 3;
      }
    },
    {
      matches: [
        'z-fix excellent',
        'z fix excellent',
        'zfix excellent'
      ],
      resolveConsumption: ({ maxSide }) => {
        if (maxSide <= 20) return 1.6;
        if (maxSide >= 60) return 2.2;
        return 1.9;
      }
    }
  ];

  namespace.resolveFastmassaConsumptionKgPerM2 = ({
    lengthCm,
    widthCm,
    title = ''
  }) => {
    const maxSide = Math.max(lengthCm, widthCm);
    const normalizedTitle =
      namespace.normalizeFastmassaTitle(title);

    const matchedProfile =
      FASTMASSA_CONSUMPTION_PROFILES.find((profile) =>
        profile.matches.some((match) =>
          normalizedTitle.includes(match)
        )
      );

    if (matchedProfile) {
      return matchedProfile.resolveConsumption({
        lengthCm,
        widthCm,
        maxSide
      });
    }

    if (maxSide <= 15) {
      return 3;
    }

    if (maxSide >= 60) {
      return 5;
    }

    return 4;
  };

  namespace.resolvePassbitarPcsPerM2 = ({
    lengthCm,
    widthCm
  }) => {
    const maxSide = Math.max(lengthCm, widthCm);
    const minSide = Math.min(lengthCm, widthCm);

    if (
      Math.abs(maxSide - 31.6) <= 1 &&
      Math.abs(minSide - 31.6) <= 1
    ) {
      return 10;
    }

    if (
      Math.abs(maxSide - 20) <= 0.6 &&
      Math.abs(minSide - 20) <= 0.6
    ) {
      return 25;
    }

    return null;
  };

  namespace.resolvePedestalSupportsPerTile = () => 5;

  namespace.resolvePackUnits = (title = '') => {
    const match = title.match(/(\d+)\s*st/i);

    if (match) {
      return Number.parseInt(match[1], 10);
    }

    return 250;
  };

  namespace.parseSerializedProducts = (serialized = '') =>
    serialized
      .split('||')
      .map((entry) => entry.trim())
      .filter(Boolean)
      .map((entry) => {
        const [
          size,
          title,
          url,
          variantId,
          available,
          price,
          imageUrl,
          kind
        ] = entry.split('~~');

        return {
          size: size || '',
          title: title || '',
          url: url || '',
          variantId: Number.parseInt(variantId, 10),
          available: available === 'true',
          price: namespace.parseLocalizedNumber(price),
          imageUrl: imageUrl || '',
          kind: kind || 'skruv',
          packUnits: namespace.resolvePackUnits(title || '')
        };
      });

  namespace.findClosestSupportedBandSize = (
    valueCm
  ) => {
    const supportedSizes = Object.keys(
      namespace.constants.EASY_LEVEL_BAND_TABLE
    )
      .map((value) => Number.parseFloat(value))
      .sort((a, b) => a - b);

    if (!Number.isFinite(valueCm)) {
      return supportedSizes[0] || 10;
    }

    return supportedSizes.reduce((closest, current) =>
      Math.abs(current - valueCm) < Math.abs(closest - valueCm)
        ? current
        : closest
    );
  };

  namespace.resolveEasyLevelBandPcsPerM2 = (
    lengthCm,
    widthCm
  ) => {
    const maxSide = namespace.findClosestSupportedBandSize(
      Math.max(lengthCm, widthCm)
    );
    const minSide = namespace.findClosestSupportedBandSize(
      Math.min(lengthCm, widthCm)
    );

    const row =
      namespace.constants.EASY_LEVEL_BAND_TABLE[maxSide] || {};

    return row[minSide] || null;
  };

  namespace.formatMoney = (amountInOre) => {
    if (!Number.isFinite(amountInOre)) {
      return '';
    }

    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function'
    ) {
      return window.Shopify.formatMoney(
        amountInOre,
        window.theme?.moneyFormat
      );
    }

    return new Intl.NumberFormat('sv-SE', {
      style: 'currency',
      currency: 'SEK',
      maximumFractionDigits: 0
    }).format(amountInOre / 100);
  };

  namespace.normalizeSize = (value = '') =>
    String(value).replace(',', '.').trim();

  namespace.findClosestProductBySize = (
    productList,
    preferredSize
  ) => {
    const normalizedPreferredSize =
      namespace.normalizeSize(preferredSize);

    const exactMatch = productList.find(
      (product) =>
        namespace.normalizeSize(product.size) ===
        normalizedPreferredSize
    );

    if (exactMatch) {
      return exactMatch;
    }

    const preferredSizeNumber =
      namespace.parseLocalizedNumber(
        normalizedPreferredSize
      );

    if (!Number.isFinite(preferredSizeNumber)) {
      return productList[0] || null;
    }

    return (
      productList
        .slice()
        .sort((productA, productB) => {
          const distanceA = Math.abs(
            namespace.parseLocalizedNumber(productA.size) -
            preferredSizeNumber
          );

          const distanceB = Math.abs(
            namespace.parseLocalizedNumber(productB.size) -
            preferredSizeNumber
          );

          return distanceA - distanceB;
        })[0] || null
    );
  };

  namespace.createContext = (calculator) => {
    const resultElement = calculator.querySelector(
      '[data-grout-result]'
    );

    const externalAreaInput =
      document.querySelector('#m2-quantity');

    const productForm =
      calculator
        .closest('section')
        ?.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    const explicitMainAddToCartButton =
      document.querySelector('#add-to-cart-main');

    const productSubmitButton =
      explicitMainAddToCartButton ||
      productForm?.querySelector(
        '[type="submit"], button[name="add"], [name="add"]'
      ) || null;

    const tileDimensions = namespace.parseTileDimensions(
      calculator.dataset.tileDimensions
    );

    const tileThicknessMm = namespace.parseLocalizedNumber(
      calculator.dataset.tileThickness
    );

    const jointWidthMm = namespace.parseLocalizedNumber(
      calculator.dataset.jointWidth
    );

    const packageWeightGrams =
      namespace.parseLocalizedNumber(
        calculator.dataset.groutPackageWeightGrams
      );

    const groutHandle =
      calculator.dataset.groutHandle || '';

    const groutTitle =
      calculator.dataset.groutTitle || 'fogmassan';

    const siliconeTitle =
      calculator.dataset.siliconeTitle || 'silikonet';
    const fastmassaTitle =
      calculator.dataset.fastmassaTitle || 'fästmassa';
    const primerTitle =
      calculator.dataset.primerTitle || 'primer';
    const passbitarTitle =
      calculator.dataset.passbitarTitle || 'passbitar';
    const piedestalTitle =
      calculator.dataset.piedestalTitle || 'piedestal';
    const underlayTitle =
      calculator.dataset.golvunderlagTitle || 'golvunderlag';

    const levelingProducts =
      namespace.parseSerializedProducts(
        calculator.dataset.levelingProducts || ''
      );

    const levelingHat =
      namespace.parseSerializedProducts(
        calculator.dataset.levelingHat || ''
      )[0] || null;

    const levelingGun =
      namespace.parseSerializedProducts(
        calculator.dataset.levelingGun || ''
      )[0] || null;

    const spacerProducts =
      namespace.parseSerializedProducts(
        calculator.dataset.spacerProducts || ''
      );

    const passbitarProducts =
      namespace.parseSerializedProducts(
        calculator.dataset.passbitarProducts || ''
      );

    const ctx = {
      calculator,
      elements: {
        resultElement,
        addButton: calculator.querySelector(
          '[data-add-grout]'
        ),
        cartMessage: calculator.querySelector(
          '[data-cart-message]'
        ),
        packageWeightOutput: calculator.querySelector(
          '[data-package-weight-output]'
        ),
        detailsPackageWeight: calculator.querySelector(
          '[data-details-package-weight]'
        ),
        selectedAreaOutput: calculator.querySelector(
          '[data-selected-area-output]'
        ),
        underlayResultElement: calculator.querySelector(
          '[data-underlay-result]'
        ),
        addUnderlayButton: calculator.querySelector(
          '[data-add-underlay]'
        ),
        underlayCartMessage: calculator.querySelector(
          '[data-underlay-cart-message]'
        ),
        externalAreaInput,
        decreaseButton: document.querySelector('.m2-decrease'),
        increaseButton: document.querySelector('.m2-increase'),
        siliconeResultElement: calculator.querySelector(
          '[data-silicone-result]'
        ),
        addSiliconeButton: calculator.querySelector(
          '[data-add-silicone]'
        ),
        siliconeCartMessage: calculator.querySelector(
          '[data-silicone-cart-message]'
        ),
        fastmassaResultElement: calculator.querySelector(
          '[data-fastmassa-result]'
        ),
        addFastmassaButton: calculator.querySelector(
          '[data-add-fastmassa]'
        ),
        fastmassaCartMessage: calculator.querySelector(
          '[data-fastmassa-cart-message]'
        ),
        primerResultElement: calculator.querySelector(
          '[data-primer-result]'
        ),
        addPrimerButton: calculator.querySelector(
          '[data-add-primer]'
        ),
        primerCartMessage: calculator.querySelector(
          '[data-primer-cart-message]'
        ),
        passbitarResultElement: calculator.querySelector(
          '[data-passbitar-result]'
        ),
        addPassbitarButton: calculator.querySelector(
          '[data-add-passbitar]'
        ),
        passbitarCartMessage: calculator.querySelector(
          '[data-passbitar-cart-message]'
        ),
        passbitarProductButtons: Array.from(
          calculator.querySelectorAll(
            '[data-passbitar-option]'
          )
        ),
        passbitarImageLink: calculator.querySelector(
          '[data-passbitar-image-link]'
        ),
        passbitarNameElement: calculator.querySelector(
          '[data-passbitar-name]'
        ),
        passbitarPriceElement: calculator.querySelector(
          '[data-passbitar-price]'
        ),
        passbitarImageElement: calculator.querySelector(
          '[data-passbitar-image]'
        ),
        piedestalResultElement: calculator.querySelector(
          '[data-piedestal-result]'
        ),
        addPiedestalButton: calculator.querySelector(
          '[data-add-piedestal]'
        ),
        piedestalCartMessage: calculator.querySelector(
          '[data-piedestal-cart-message]'
        ),
        siliconeScenarioSelect: calculator.querySelector(
          '[data-silicone-scenario]'
        ),
        siliconeManualMetersInput: calculator.querySelector(
          '[data-silicone-manual-meters]'
        ),
        siliconeJointWidthInput: calculator.querySelector(
          '[data-silicone-joint-width]'
        ),
        siliconeJointDepthInput: calculator.querySelector(
          '[data-silicone-joint-depth]'
        ),
        siliconeShapeSelect: calculator.querySelector(
          '[data-silicone-shape]'
        ),
        levelingResultElement: calculator.querySelector(
          '[data-leveling-result]'
        ),
        addLevelingButton: calculator.querySelector(
          '[data-add-leveling]'
        ),
        addLevelingHatButton: calculator.querySelector(
          '[data-add-leveling-hat]'
        ),
        levelingCartMessage: calculator.querySelector(
          '[data-leveling-cart-message]'
        ),
        levelingHatCartMessage: calculator.querySelector(
          '[data-leveling-hat-cart-message]'
        ),
        levelingGunCartMessage: calculator.querySelector(
          '[data-leveling-gun-cart-message]'
        ),
        levelingHatResultElement: calculator.querySelector(
          '[data-leveling-hat-result]'
        ),
        levelingGunResultElement: calculator.querySelector(
          '[data-leveling-gun-result]'
        ),
        levelingSizeSelect: calculator.querySelector(
          '[data-leveling-size]'
        ),
        levelingSizeButtons: Array.from(
          calculator.querySelectorAll(
            '[data-leveling-size-button]'
          )
        ),
        addLevelingGunButton: calculator.querySelector(
          '[data-add-leveling-gun]'
        ),
        levelingImageLink: calculator.querySelector(
          '[data-leveling-image-link]'
        ),
        levelingNameElement: calculator.querySelector(
          '[data-leveling-name]'
        ),
        levelingPriceElement: calculator.querySelector(
          '[data-leveling-price]'
        ),
        levelingImageElement: calculator.querySelector(
          '[data-leveling-image]'
        ),
        spacerResultElement: calculator.querySelector(
          '[data-spacer-result]'
        ),
        addSpacerButton: calculator.querySelector(
          '[data-add-spacer]'
        ),
        spacerCartMessage: calculator.querySelector(
          '[data-spacer-cart-message]'
        ),
        spacerSizeSelect: calculator.querySelector(
          '[data-spacer-size]'
        ),
        spacerImageLink: calculator.querySelector(
          '[data-spacer-image-link]'
        ),
        spacerNameElement: calculator.querySelector(
          '[data-spacer-name]'
        ),
        spacerPriceElement: calculator.querySelector(
          '[data-spacer-price]'
        ),
        spacerImageElement: calculator.querySelector(
          '[data-spacer-image]'
        ),
        bundleSummaryElement: calculator.querySelector(
          '[data-bundle-summary]'
        ),
        quickCardElement: calculator.querySelector(
          '.grout-calculator__quick'
        ),
        bundleCheckbox: calculator.querySelector(
          '[data-bundle-checkbox]'
        ),
        bundleCartMessage: calculator.querySelector(
          '[data-bundle-cart-message]'
        ),
        drawerAreaOutput: calculator.querySelector(
          '[data-drawer-area-output]'
        ),
        drawerAreaDecreaseButton: calculator.querySelector(
          '[data-drawer-area-decrease]'
        ),
        drawerAreaIncreaseButton: calculator.querySelector(
          '[data-drawer-area-increase]'
        ),
        productForm,
        productSubmitButton
      },
      data: {
        calculatorScope:
          calculator.dataset.calculatorScope || 'bundle',
        tileDimensions,
        tileThicknessMm,
        jointWidthMm,
        packageWeightKg: packageWeightGrams / 1000,
        groutVariantId: Number.parseInt(
          calculator.dataset.groutVariantId,
          10
        ),
        groutVariantAvailable:
          calculator.dataset.groutVariantAvailable ===
          'true',
        groutPrice: namespace.parseLocalizedNumber(
          calculator.dataset.groutPrice
        ),
        groutTitle,
        groutCoefficient:
          namespace.resolveGroutCoefficient(groutHandle),
        siliconeTitle,
        siliconeVariantId: Number.parseInt(
          calculator.dataset.siliconeVariantId,
          10
        ),
        siliconeVariantAvailable:
          calculator.dataset.siliconeVariantAvailable ===
          'true',
        siliconePrice: namespace.parseLocalizedNumber(
          calculator.dataset.siliconePrice
        ),
        siliconeVolumeMl:
          namespace.resolveSiliconeVolumeMl(siliconeTitle),
        fastmassaTitle,
        fastmassaVariantId: Number.parseInt(
          calculator.dataset.fastmassaVariantId,
          10
        ),
        fastmassaVariantAvailable:
          calculator.dataset.fastmassaVariantAvailable ===
          'true',
        fastmassaPrice: namespace.parseLocalizedNumber(
          calculator.dataset.fastmassaPrice
        ),
        fastmassaPackageKg:
          namespace.resolveFastmassaPackageKg(
            fastmassaTitle
          ),
        primerTitle,
        primerVariantId: Number.parseInt(
          calculator.dataset.primerVariantId,
          10
        ),
        primerVariantAvailable:
          calculator.dataset.primerVariantAvailable ===
          'true',
        primerPrice: namespace.parseLocalizedNumber(
          calculator.dataset.primerPrice
        ),
        primerPackageUnits:
          namespace.resolvePrimerPackageUnits(primerTitle),
        passbitarTitle,
        passbitarVariantId: Number.parseInt(
          calculator.dataset.passbitarVariantId,
          10
        ),
        passbitarVariantAvailable:
          calculator.dataset.passbitarVariantAvailable ===
          'true',
        passbitarPackUnits: 1,
        piedestalTitle,
        piedestalVariantId: Number.parseInt(
          calculator.dataset.piedestalVariantId,
          10
        ),
        piedestalVariantAvailable:
          calculator.dataset.piedestalVariantAvailable ===
          'true',
        piedestalPrice: namespace.parseLocalizedNumber(
          calculator.dataset.piedestalPrice
        ),
        piedestalPackUnits: 1,
        underlayTitle,
        underlayVariantId: Number.parseInt(
          calculator.dataset.golvunderlagVariantId,
          10
        ),
        underlayVariantAvailable:
          calculator.dataset.golvunderlagVariantAvailable ===
          'true',
        underlayPrice: namespace.parseLocalizedNumber(
          calculator.dataset.golvunderlagPrice
        ),
        underlayCoverageM2: namespace.parseLocalizedNumber(
          calculator.dataset.golvunderlagCoverageM2
        ),
        levelingProducts,
        levelingHat,
        levelingGun,
        passbitarProducts,
        spacerProducts
      },
      state: {
        recommendedPackages: 0,
        calculatedAreaM2: 0,
        recommendedSiliconeUnits: 0,
        recommendedFastmassaUnits: 0,
        recommendedPrimerUnits: 0,
        recommendedPassbitarUnits: 0,
        recommendedPiedestalUnits: 0,
        recommendedUnderlayUnits: 0,
        recommendedLevelingUnits: 0,
        recommendedLevelingHatUnits: 0,
        recommendedLevelingGunUnits: 0,
        recommendedSpacerUnits: 0,
        bundleAddInProgress: false,
        bundleAutoAddTimeout: null,
        lastBundleQueueAt: 0,
        selectedLevelingProduct: null,
        selectedPassbitarProduct: null,
        selectedSpacerProduct: null
      }
    };

    const initialLevelingSize =
      namespace.resolveRecommendedLevelingSize(ctx);

    ctx.state.selectedLevelingProduct =
      namespace.findClosestProductBySize(
        levelingProducts,
        initialLevelingSize
      ) || levelingProducts[0] || null;

    const initialSpacerSize =
      namespace.resolveRecommendedSpacerSize(ctx);

    ctx.state.selectedPassbitarProduct =
      passbitarProducts[0] || null;

    ctx.state.selectedSpacerProduct =
      namespace.findClosestProductBySize(
        spacerProducts,
        initialSpacerSize
      ) || spacerProducts[0] || null;

    namespace.syncLevelingProductUI(ctx);
    namespace.syncPassbitarProductUI(ctx);
    namespace.syncSpacerProductUI(ctx);
    namespace.syncPackageWeightUI(ctx);

    return ctx;
  };

  namespace.syncPackageWeightUI = (ctx) => {
    const { packageWeightKg } = ctx.data;
    const {
      packageWeightOutput,
      detailsPackageWeight
    } = ctx.elements;

    if (
      !Number.isFinite(packageWeightKg) ||
      packageWeightKg <= 0
    ) {
      return;
    }

    const formattedWeight =
      namespace.formatWeight(packageWeightKg);

    if (packageWeightOutput) {
      packageWeightOutput.textContent = formattedWeight;
    }

    if (detailsPackageWeight) {
      detailsPackageWeight.textContent = formattedWeight;
    }
  };

  namespace.getUpsellDrawerSelectedQuantity = (
    ctx,
    options = {}
  ) => {
    if (
      !ctx ||
      ctx.calculator?.dataset?.calculatorOwner !== 'upsells'
    ) {
      return null;
    }

    const metafield =
      options.metafield || ctx.data.calculatorScope || '';

    if (!metafield) {
      return null;
    }

    const drawerContent = ctx.calculator.closest(
      '.customize-drawer-content-upsells'
    );

    if (!drawerContent) {
      return null;
    }

    const wrappers = Array.from(
      drawerContent.querySelectorAll(
        `.drawer-product-wrapper-upsells[data-metafield="${metafield}"]`
      )
    );

    if (!wrappers.length) {
      return null;
    }

    let preferredVariantId = Number(options.variantId || 0);

    if (!preferredVariantId) {
      switch (metafield) {
        case 'fogmassa':
          preferredVariantId = Number(ctx.data.groutVariantId || 0);
          break;
        case 'silikon':
          preferredVariantId = Number(
            ctx.data.siliconeVariantId || 0
          );
          break;
        case 'fastmassa':
          preferredVariantId = Number(
            ctx.data.fastmassaVariantId || 0
          );
          break;
        case 'primer':
          preferredVariantId = Number(
            ctx.data.primerVariantId || 0
          );
          break;
        case 'golvunderlag':
          preferredVariantId = Number(
            ctx.data.underlayVariantId || 0
          );
          break;
        case 'piedestal':
          preferredVariantId = Number(
            ctx.data.piedestalVariantId || 0
          );
          break;
        case 'passbitar':
          preferredVariantId = Number(
            ctx.state.selectedPassbitarProduct?.variantId || 0
          );
          break;
        case 'nivaskruv':
          preferredVariantId = Number(
            ctx.state.selectedLevelingProduct?.variantId ||
              ctx.state.selectedSpacerProduct?.variantId ||
              0
          );
          break;
      }
    }

    const activeWrapper = wrappers.find((wrapper) =>
      wrapper.classList.contains(
        'drawer-product-wrapper-upsells--active'
      )
    );

    const matchingWrapper =
      activeWrapper ||
      wrappers.find((wrapper) => {
        const productId = Number(
          wrapper
            .querySelector('.product-item-upsells')
            ?.dataset?.productId || 0
        );
        return (
          preferredVariantId > 0 &&
          productId === preferredVariantId
        );
      }) ||
      wrappers.find((wrapper) =>
        wrapper.classList.contains(
          'drawer-product-wrapper-upsells--recommended'
        )
      ) ||
      wrappers.find((wrapper) =>
        wrapper.classList.contains('selected')
      ) ||
      wrappers[0];

    const quantityInput = matchingWrapper?.querySelector(
      '.qty-input-upsells'
    );
    const selectedQuantity = Number.parseInt(
      quantityInput?.value || '1',
      10
    );

    return Number.isFinite(selectedQuantity) &&
      selectedQuantity > 0
      ? selectedQuantity
      : 1;
  };

  namespace.isUpsellsDrawerCalculator = (ctx) =>
    Boolean(
      ctx &&
        ctx.calculator?.dataset?.calculatorOwner ===
          'upsells'
    );

  namespace.resolveRecommendedLevelingSize = (ctx) => {
    const { jointWidthMm } = ctx.data;

    if (
      Number.isFinite(jointWidthMm) &&
      jointWidthMm <= 1.25
    ) {
      return '1';
    }

    if (
      Number.isFinite(jointWidthMm) &&
      jointWidthMm <= 1.75
    ) {
      return '1.5';
    }

    return '2';
  };

  namespace.resolveRecommendedSpacerSize = (ctx) => {
    const { jointWidthMm } = ctx.data;

    if (!Number.isFinite(jointWidthMm) || jointWidthMm <= 0) {
      return '2';
    }

    if (jointWidthMm <= 1) {
      return '1';
    }

    if (jointWidthMm <= 1.5) {
      return '1.5';
    }

    if (jointWidthMm <= 2) {
      return '2';
    }

    return '3';
  };

  namespace.syncLevelingProductUI = (ctx) => {
    const { selectedLevelingProduct } = ctx.state;
    const {
      levelingSizeSelect,
      levelingSizeButtons,
      levelingNameElement,
      levelingImageLink,
      levelingImageElement,
      levelingPriceElement
    } = ctx.elements;

    if (!selectedLevelingProduct) {
      return;
    }

    if (levelingSizeSelect) {
      levelingSizeSelect.value =
        selectedLevelingProduct.size;
    }

    if (levelingSizeButtons?.length) {
      levelingSizeButtons.forEach((button) => {
        const isActive =
          namespace.normalizeSize(
            button.dataset.levelingSizeValue || ''
          ) ===
          namespace.normalizeSize(
            selectedLevelingProduct.size || ''
          );

        button.classList.toggle(
          'is-active',
          isActive
        );
        button.setAttribute(
          'aria-pressed',
          isActive ? 'true' : 'false'
        );
      });
    }

    if (levelingNameElement) {
      levelingNameElement.textContent =
        selectedLevelingProduct.title;
      levelingNameElement.href =
        selectedLevelingProduct.url;
    }

    if (levelingImageLink) {
      levelingImageLink.href =
        selectedLevelingProduct.url;
    }

    if (
      levelingImageElement &&
      selectedLevelingProduct.imageUrl
    ) {
      levelingImageElement.src =
        selectedLevelingProduct.imageUrl;
      levelingImageElement.alt =
        selectedLevelingProduct.title;
    }

    if (levelingPriceElement) {
      levelingPriceElement.textContent =
        namespace.formatMoney(
          selectedLevelingProduct.price
        );
    }
  };

  namespace.syncSpacerProductUI = (ctx) => {
    const { selectedSpacerProduct } = ctx.state;
    const {
      spacerSizeSelect,
      spacerNameElement,
      spacerImageLink,
      spacerImageElement,
      spacerPriceElement
    } = ctx.elements;

    if (!selectedSpacerProduct) {
      return;
    }

    if (spacerSizeSelect) {
      spacerSizeSelect.value = selectedSpacerProduct.size;
    }

    if (spacerNameElement) {
      spacerNameElement.textContent =
        selectedSpacerProduct.title;
      spacerNameElement.href =
        selectedSpacerProduct.url;
    }

    if (spacerImageLink) {
      spacerImageLink.href = selectedSpacerProduct.url;
    }

    if (
      spacerImageElement &&
      selectedSpacerProduct.imageUrl
    ) {
      spacerImageElement.src =
        selectedSpacerProduct.imageUrl;
      spacerImageElement.alt =
        selectedSpacerProduct.title;
    }

    if (spacerPriceElement) {
      spacerPriceElement.textContent =
        namespace.formatMoney(selectedSpacerProduct.price);
    }
  };

  namespace.syncPassbitarProductUI = (ctx) => {
    const { selectedPassbitarProduct } = ctx.state;
    const {
      passbitarProductButtons,
      passbitarNameElement,
      passbitarImageLink,
      passbitarImageElement,
      passbitarPriceElement
    } = ctx.elements;

    if (!selectedPassbitarProduct) {
      return;
    }

    passbitarProductButtons?.forEach((button) => {
      const isActive =
        button.dataset.passbitarVariantId ===
        String(selectedPassbitarProduct.variantId);

      button.classList.toggle('is-active', isActive);
      button.setAttribute(
        'aria-pressed',
        isActive ? 'true' : 'false'
      );
    });

    if (passbitarNameElement) {
      passbitarNameElement.textContent =
        selectedPassbitarProduct.title;
      passbitarNameElement.href =
        selectedPassbitarProduct.url;
    }

    if (passbitarImageLink) {
      passbitarImageLink.href =
        selectedPassbitarProduct.url;
    }

    if (
      passbitarImageElement &&
      selectedPassbitarProduct.imageUrl
    ) {
      passbitarImageElement.src =
        selectedPassbitarProduct.imageUrl;
      passbitarImageElement.srcset =
        selectedPassbitarProduct.imageUrl;
      passbitarImageElement.alt =
        selectedPassbitarProduct.title;
    }

    if (passbitarPriceElement) {
      passbitarPriceElement.textContent =
        namespace.formatMoney(
          selectedPassbitarProduct.price
        );
    }
  };

  namespace.getBundleItems = (ctx) => {
    const items = [];
    const {
      groutVariantId,
      groutVariantAvailable,
      groutPrice,
      groutTitle,
      siliconeVariantId,
      siliconeVariantAvailable,
      siliconePrice,
      siliconeTitle,
      fastmassaVariantId,
      fastmassaVariantAvailable,
      fastmassaPrice,
      fastmassaTitle,
      primerVariantId,
      primerVariantAvailable,
      primerPrice,
      primerTitle,
      piedestalVariantId,
      piedestalVariantAvailable,
      piedestalPrice,
      piedestalTitle,
      underlayVariantId,
      underlayVariantAvailable,
      underlayPrice,
      underlayTitle,
      levelingHat,
      levelingGun
    } = ctx.data;
    const {
      recommendedPackages,
      recommendedSiliconeUnits,
      recommendedFastmassaUnits,
      recommendedPrimerUnits,
      recommendedPassbitarUnits,
      recommendedPiedestalUnits,
      recommendedUnderlayUnits,
      recommendedLevelingUnits,
      recommendedLevelingHatUnits,
      recommendedLevelingGunUnits,
      recommendedSpacerUnits,
      selectedLevelingProduct,
      selectedPassbitarProduct,
      selectedSpacerProduct
    } = ctx.state;

    if (
      Number.isFinite(groutVariantId) &&
      groutVariantId > 0 &&
      recommendedPackages > 0 &&
      groutVariantAvailable
    ) {
      items.push({
        metafield: 'fogmassa',
        id: groutVariantId,
        quantity: recommendedPackages,
        unitPrice: groutPrice,
        label: `${recommendedPackages} × ${groutTitle}`,
        shortLabel: `Fog × ${recommendedPackages}`
      });
    }

    if (
      Number.isFinite(siliconeVariantId) &&
      siliconeVariantId > 0 &&
      recommendedSiliconeUnits > 0 &&
      siliconeVariantAvailable
    ) {
      items.push({
        metafield: 'silikon',
        id: siliconeVariantId,
        quantity: recommendedSiliconeUnits,
        unitPrice: siliconePrice,
        label: `${recommendedSiliconeUnits} × ${siliconeTitle}`,
        shortLabel: `Silikon × ${recommendedSiliconeUnits}`
      });
    }

    if (
      Number.isFinite(fastmassaVariantId) &&
      fastmassaVariantId > 0 &&
      recommendedFastmassaUnits > 0 &&
      fastmassaVariantAvailable
    ) {
      items.push({
        metafield: 'fastmassa',
        id: fastmassaVariantId,
        quantity: recommendedFastmassaUnits,
        unitPrice: fastmassaPrice,
        label: `${recommendedFastmassaUnits} × ${fastmassaTitle}`,
        shortLabel: `Fix × ${recommendedFastmassaUnits}`
      });
    }

    if (
      Number.isFinite(primerVariantId) &&
      primerVariantId > 0 &&
      recommendedPrimerUnits > 0 &&
      primerVariantAvailable
    ) {
      items.push({
        metafield: 'primer',
        id: primerVariantId,
        quantity: recommendedPrimerUnits,
        unitPrice: primerPrice,
        label: `${recommendedPrimerUnits} × ${primerTitle}`,
        shortLabel: `Primer × ${recommendedPrimerUnits}`
      });
    }

    if (
      selectedPassbitarProduct &&
      Number.isFinite(selectedPassbitarProduct.variantId) &&
      selectedPassbitarProduct.variantId > 0 &&
      recommendedPassbitarUnits > 0 &&
      selectedPassbitarProduct.available
    ) {
      items.push({
        metafield: 'passbitar',
        id: selectedPassbitarProduct.variantId,
        quantity: recommendedPassbitarUnits,
        unitPrice: selectedPassbitarProduct.price,
        label: `${recommendedPassbitarUnits} × ${selectedPassbitarProduct.title}`,
        shortLabel: `Passbitar × ${recommendedPassbitarUnits}`
      });
    }

    if (
      Number.isFinite(piedestalVariantId) &&
      piedestalVariantId > 0 &&
      recommendedPiedestalUnits > 0 &&
      piedestalVariantAvailable
    ) {
      items.push({
        metafield: 'piedestal',
        id: piedestalVariantId,
        quantity: recommendedPiedestalUnits,
        unitPrice: piedestalPrice,
        label: `${recommendedPiedestalUnits} × ${piedestalTitle}`,
        shortLabel: `Piedestal × ${recommendedPiedestalUnits}`
      });
    }

    if (
      Number.isFinite(underlayVariantId) &&
      underlayVariantId > 0 &&
      recommendedUnderlayUnits > 0 &&
      underlayVariantAvailable
    ) {
      items.push({
        metafield: 'golvunderlag',
        id: underlayVariantId,
        quantity: recommendedUnderlayUnits,
        unitPrice: underlayPrice,
        label: `${recommendedUnderlayUnits} × ${underlayTitle}`,
        shortLabel: `Underlag × ${recommendedUnderlayUnits}`
      });
    }

    if (
      selectedLevelingProduct &&
      Number.isFinite(selectedLevelingProduct.variantId) &&
      selectedLevelingProduct.variantId > 0 &&
      recommendedLevelingUnits > 0 &&
      selectedLevelingProduct.available
    ) {
      const levelingShortLabel =
        selectedLevelingProduct.kind === 'band'
          ? `Nivåband × ${recommendedLevelingUnits}`
          : `Nivåskruv × ${recommendedLevelingUnits}`;

      items.push({
        metafield: 'nivaskruv',
        id: selectedLevelingProduct.variantId,
        quantity: recommendedLevelingUnits,
        unitPrice: selectedLevelingProduct.price,
        label: `${recommendedLevelingUnits} × ${selectedLevelingProduct.title}`,
        shortLabel: levelingShortLabel
      });
    }

    return items;
  };

  namespace.refreshBundleUI = (ctx) => {
    const {
      externalAreaInput,
      bundleSummaryElement,
      bundleCheckbox,
      quickCardElement,
      drawerAreaOutput
    } = ctx.elements;

    const parsedAreaM2 = namespace.parseLocalizedNumber(
      externalAreaInput?.value
    );

    ctx.state.calculatedAreaM2 =
      Number.isFinite(parsedAreaM2) && parsedAreaM2 > 0
        ? parsedAreaM2
        : 0;

    if (drawerAreaOutput) {
      drawerAreaOutput.textContent =
        ctx.state.calculatedAreaM2 > 0
          ? `${namespace.formatNumber(ctx.state.calculatedAreaM2)} m²`
          : '–';
    }

    const { calculatedAreaM2 } = ctx.state;

    const areaIsValid =
      Number.isFinite(calculatedAreaM2) &&
      calculatedAreaM2 > 0;

    const bundleItems = namespace.getBundleItems(ctx);

    const dispatchBundleUpdate = () => {
      document.dispatchEvent(
        new CustomEvent('kg:bundle-recommendations-updated', {
          bubbles: true,
          detail: {
            scope: ctx.data.calculatorScope || 'bundle',
            tileId: ctx.calculator.dataset.tileId,
            areaM2: calculatedAreaM2,
            items: bundleItems,
            checked: Boolean(bundleCheckbox?.checked),
            categoryCount: new Set(
              bundleItems.map((item) => item.metafield)
            ).size
          }
        })
      );
    };

    if (!bundleSummaryElement) {
      dispatchBundleUpdate();
      return;
    }

    if (!areaIsValid) {
      bundleSummaryElement.innerHTML =
        '<p>Välj antal m² ovan för att se våra rekommendationer.</p>';

      if (bundleCheckbox) {
        bundleCheckbox.checked = false;
        bundleCheckbox.disabled = true;
      }

      if (quickCardElement) {
        quickCardElement.classList.remove(
          'grout-calculator__quick--selected'
        );
      }

      dispatchBundleUpdate();
      return;
    }

    if (!bundleItems.length) {
      bundleSummaryElement.innerHTML =
        '<p>Vi kunde inte ta fram några rekommendationer för vald yta ännu.</p>';

      if (bundleCheckbox) {
        bundleCheckbox.checked = false;
        bundleCheckbox.disabled = true;
      }

      if (quickCardElement) {
        quickCardElement.classList.remove(
          'grout-calculator__quick--selected'
        );
      }

      dispatchBundleUpdate();
      return;
    }

    bundleSummaryElement.innerHTML = `
      <p class="grout-calculator__quick-result">
        För <strong>${namespace.formatNumber(calculatedAreaM2)} m²</strong> rekommenderar vi totalt <strong>${bundleItems.length} tillval</strong>.
      </p>
      <ul class="grout-calculator__quick-list">
        ${bundleItems
          .map(
            (item) => `
              <li class="grout-calculator__quick-item" title="${item.label}">${item.shortLabel}</li>
            `
          )
          .join('')}
      </ul>
    `;

    if (bundleCheckbox) {
      bundleCheckbox.disabled = false;
    }

    if (quickCardElement) {
      quickCardElement.classList.toggle(
        'grout-calculator__quick--selected',
        Boolean(bundleCheckbox?.checked)
      );
    }

    dispatchBundleUpdate();
  };

  namespace.adjustDrawerArea = (ctx, direction = 1) => {
    const { externalAreaInput, increaseButton, decreaseButton } =
      ctx.elements;

    if (direction > 0 && increaseButton) {
      increaseButton.click();
      return;
    }

    if (direction < 0 && decreaseButton) {
      decreaseButton.click();
      return;
    }

    if (!externalAreaInput) {
      return;
    }

    const step =
      namespace.parseLocalizedNumber(
        ctx.calculator.dataset.sqmPerPackage
      ) || 1;

    const currentValue =
      namespace.parseLocalizedNumber(externalAreaInput.value) ||
      step;

    const nextValue =
      direction > 0
        ? currentValue + step
        : Math.max(step, currentValue - step);

    externalAreaInput.value = String(nextValue).replace(
      '.',
      ','
    );

    externalAreaInput.dispatchEvent(
      new Event('input', { bubbles: true })
    );
    externalAreaInput.dispatchEvent(
      new Event('blur', { bubbles: true })
    );
  };

  namespace.mountFogmassaDrawerLayout = (ctx) => {
    if (ctx.data.calculatorScope !== 'fogmassa') {
      return;
    }

    if (ctx.calculator.dataset.calculatorOwner === 'upsells') {
      return;
    }

    if (
      ctx.calculator.closest('.kg-drawer-recommendation-slot--hidden') ||
      ctx.calculator.closest('[aria-hidden="true"]')
    ) {
      return;
    }

    const drawerContent = ctx.calculator.closest(
      '.customize-drawer-content-upsells'
    );

    if (!drawerContent || ctx.calculator.dataset.layoutMounted === 'true') {
      return;
    }

    const descriptionElement = drawerContent.querySelector(
      '.description-customize'
    );
    const separatorElement = drawerContent.querySelector('hr');
    const productWrapper = drawerContent.querySelector(
      '.drawer-product-wrapper-upsells[data-metafield="fogmassa"]'
    );
    const heroElement = ctx.calculator.querySelector(
      '.grout-calculator__drawer-hero'
    );
    const bodyElement = ctx.calculator.querySelector(
      '.grout-calculator__body'
    );

    if (heroElement && productWrapper) {
      const referenceNode = separatorElement || descriptionElement;

      if (referenceNode) {
        referenceNode.insertAdjacentElement('afterend', heroElement);
      } else {
        drawerContent.prepend(heroElement);
      }

      productWrapper.insertAdjacentElement('beforebegin', heroElement);
    }

    if (bodyElement && productWrapper) {
      productWrapper.insertAdjacentElement('afterend', bodyElement);
    }

    ctx.calculator.dataset.layoutMounted = 'true';
  };

  namespace.mountLevelingDrawerLayout = (ctx) => {
    if (ctx.data.calculatorScope !== 'nivaskruv') {
      return;
    }

    if (ctx.calculator.dataset.calculatorOwner === 'upsells') {
      return;
    }

    if (
      ctx.calculator.closest('.kg-drawer-recommendation-slot--hidden') ||
      ctx.calculator.closest('[aria-hidden="true"]')
    ) {
      return;
    }

    const drawerContent = ctx.calculator.closest(
      '.customize-drawer-content-upsells'
    );

    if (!drawerContent || ctx.calculator.dataset.layoutMounted === 'true') {
      return;
    }

    const descriptionElement = drawerContent.querySelector(
      '.description-customize'
    );
    const separatorElement = drawerContent.querySelector('hr');
    const firstProductWrapper = drawerContent.querySelector(
      '.drawer-product-wrapper-upsells[data-metafield="nivaskruv"]'
    );
    const heroElement = ctx.calculator.querySelector(
      '.grout-calculator__drawer-hero'
    );
    const bodyElement = ctx.calculator.querySelector(
      '.leveling-calculator'
    );

    if (firstProductWrapper && heroElement) {
      firstProductWrapper.insertAdjacentElement(
        'beforebegin',
        heroElement
      );
    } else if (heroElement) {
      const referenceNode = separatorElement || descriptionElement;

      if (referenceNode) {
        referenceNode.insertAdjacentElement(
          'afterend',
          heroElement
        );
      }
    }

    if (firstProductWrapper && bodyElement) {
      heroElement?.insertAdjacentElement('afterend', bodyElement);
    }

    ctx.calculator.dataset.layoutMounted = 'true';
  };

  namespace.mountUnderlayDrawerLayout = (ctx) => {
    if (ctx.data.calculatorScope !== 'golvunderlag') {
      return;
    }

    if (ctx.calculator.dataset.calculatorOwner === 'upsells') {
      return;
    }

    if (
      ctx.calculator.closest('.kg-drawer-recommendation-slot--hidden') ||
      ctx.calculator.closest('[aria-hidden="true"]')
    ) {
      return;
    }

    const drawerContent = ctx.calculator.closest(
      '.customize-drawer-content-upsells'
    );

    if (!drawerContent || ctx.calculator.dataset.layoutMounted === 'true') {
      return;
    }

    const descriptionElement = drawerContent.querySelector(
      '.description-customize'
    );
    const separatorElement = drawerContent.querySelector('hr');
    const firstProductWrapper = drawerContent.querySelector(
      '.drawer-product-wrapper-upsells[data-metafield="golvunderlag"]'
    );
    const heroElement = ctx.calculator.querySelector(
      '.grout-calculator__drawer-hero'
    );
    const bodyElement = ctx.calculator.querySelector(
      '.underlay-calculator'
    );

    if (firstProductWrapper && heroElement) {
      firstProductWrapper.insertAdjacentElement(
        'beforebegin',
        heroElement
      );
    } else if (heroElement) {
      const referenceNode = separatorElement || descriptionElement;

      if (referenceNode) {
        referenceNode.insertAdjacentElement(
          'afterend',
          heroElement
        );
      }
    }

    if (firstProductWrapper && bodyElement) {
      heroElement?.insertAdjacentElement('afterend', bodyElement);
    }

    ctx.calculator.dataset.layoutMounted = 'true';
  };

  namespace.syncUpsellDrawerRecommendation = (
    ctx,
    {
      metafield,
      variantId,
      quantity,
      autoSelect = false
    }
  ) => {
    if (
      !metafield ||
      !Number.isFinite(variantId) ||
      variantId <= 0 ||
      !Number.isFinite(quantity) ||
      quantity < 1
    ) {
      return;
    }

    if (
      typeof window.KGSyncUpsellRecommendation !==
      'function'
    ) {
      return;
    }

    window.KGSyncUpsellRecommendation({
      metafield,
      variantId,
      quantity,
      autoSelect
    });
  };

  namespace.validateBaseData = (ctx) => {
    const { externalAreaInput } = ctx.elements;
    const {
      tileDimensions,
      tileThicknessMm,
      jointWidthMm,
      packageWeightKg,
      groutVariantId
    } = ctx.data;

    if (!externalAreaInput) {
      return 'Kunde inte hitta m²-fältet med ID m2-quantity.';
    }

    if (!tileDimensions) {
      return 'Plattans storlek kunde inte tolkas.';
    }

    if (
      !Number.isFinite(tileThicknessMm) ||
      tileThicknessMm <= 0
    ) {
      return 'Plattans tjocklek saknas eller är ogiltig.';
    }

    if (
      !Number.isFinite(jointWidthMm) ||
      jointWidthMm <= 0
    ) {
      return 'Fogbredden saknas eller är ogiltig.';
    }

    if (
      !Number.isFinite(packageWeightKg) ||
      packageWeightKg <= 0
    ) {
      return 'Fogmassans förpackningsvikt saknas eller är ogiltig.';
    }

    if (
      !Number.isFinite(groutVariantId) ||
      groutVariantId <= 0
    ) {
      return 'Fogmassans produkt-ID kunde inte hämtas.';
    }

    return null;
  };

  namespace.showError = (ctx, message) => {
    const { resultElement, selectedAreaOutput, addButton } =
      ctx.elements;

    ctx.state.recommendedPackages = 0;
    ctx.state.calculatedAreaM2 = 0;

    resultElement.innerHTML = `
      <p class="grout-calculator__error">
        ${message}
      </p>
    `;

    if (selectedAreaOutput) {
      selectedAreaOutput.textContent = '–';
    }

    if (addButton) {
      addButton.disabled = true;
    }

    namespace.refreshBundleUI(ctx);
  };
})();
